import React from 'react';
import SEO from './components/SEO';
import './styles.css';

const LogoPage: React.FC = () => {
  return (
    <div className="logo-page">
      <SEO
        title="NOPRBLM | Logo Assets"
        description="Logo assets for NOPRBLM"
        keywords="NOPRBLM, logo, brand assets"
        canonicalUrl="/logo-assets"
      />
      
      <div className="logo-container">
        <div className="logo-display">
          <h1>NOPRBLM</h1>
        </div>
        
        <div className="logo-info">
          <p>Font: Futura Cyrillic Light</p>
          <p>Color: #FFFFFF on #000000</p>
        </div>
        
        <div className="logo-instructions">
          <h2>Usage Instructions</h2>
          <p>1. Take a screenshot of the logo above</p>
          <p>2. Maintain at least 20px of clear space around the logo</p>
          <p>3. Do not distort, rotate, or change the color of the logo</p>
        </div>
        
        <div className="download-options">
          <a href="/BrandKit/logotransparentbackground.png" download className="download-button">
            Download PNG Logo
          </a>
        </div>
      </div>
    </div>
  );
};

export default LogoPage;